export default __webpack_public_path__ + "static/media/instagram.d6ae092b.svg";